import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import ReactHtmlParser from 'react-html-parser'
import HubspotForm from 'react-hubspot-form'
import Spinner from "react-spinners/BounceLoader"
import {
  BackgroundSection, Base, Box, Container,
  Flex,
  Heading,
  Text
} from "./ui"
import * as styles from "./ui.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const HubSpotForm = ({ setFilled, filled, email, ...props }) => {
  return (
    <Base as="div" cx={[styles.heroform]} id={'heroForm'} {...props}>
      <HubspotForm
        portalId='44645643'
        formId='62c39a77-cc9a-4830-a3e2-a9827334c927'
        region="na1"
        onSubmit={() => { setFilled(2) }}
        onFormReady={(form) => {
          form.find('input[name="email"]').val(email).change();
          console.log(form);
        }}
        loading={<Spinner color="#621ae0" />}
      />
      {(filled === 1) && (
        <Text as="p" variant="testimonialSublead2">
          Ao clicar em “Solicitar demonstração” você concorda com nossa <a href="/politica-de-privacidade">Política de privacidade</a>
        </Text>
      )}
    </Base >
  )
}

const HubSpotOnceForm = ({ setFilled, setEmail, ...props }) => {
  return (
    <Base as="div" cx={[styles.heroformnoveau]} id={'heroFormNoveau'} {...props}>
      <HubspotForm
        portalId='44645643'
        formId='01217949-fb3a-4466-9aae-f4fd5d677b19'
        region="na1"
        onSubmit={(e) => { setEmail(e[0].value); setFilled(1); }}
        onReady={() => {
          const script = document.createElement('script');
          script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
          let jqueryScript = document.getElementsByTagName('script');
          let src = Array.from(jqueryScript).filter(item => item.src === script.src)
          if (src.length === 0) {
            document.body.appendChild(script)
          }
        }}
        loading={<Spinner color="#621ae0" />}
      />
    </Base>
  )
}


export default function Hero(props) {
  const [filled, setFilled] = useState(0);
  const [email, setEmail] = useState(null)
  return (
    <BackgroundSection image={props.background} cx={[styles.herosection]}>
      <Container cx={[styles.herocontainer]}>
        <Flex cx={[styles.herosectionFlex]}>
          <Box cx={[styles.herosectionTextBox]} id="heroForm">
            {
              (filled > 0) && (
                <>
                  {(filled === 1) && <Heading as="h1" variant="secondFormHeading">
                    {ReactHtmlParser("Garanta sua demonstração gratuita!")}
                  </Heading>
                  }
                  <HubSpotForm {...{ setFilled, email, filled }} />
                </>
              )
            }
            {
              (filled === 0) && (
                <>
                  <Heading as="h1">
                    {ReactHtmlParser(props.h1)}
                  </Heading>
                  <HubSpotOnceForm name='form-principal-novo-site' {...{ setFilled, setEmail }} />
                </>
              )
            }
          </Box>
          <Box cx={[styles.heroImageBox]}>
            <Base cx={[styles.heroImageBoxCenter]}>
              <Base as="div" cx={[styles.heroOuterImages]} id={'heroOuterImages'} {...props}>
                <Base as="div" cx={[styles.heroSubOuterImages]} id={'heroSubOuterImages'} {...props}>
                  {props.floatingFirst && (
                    <Base
                      as={GatsbyImage}
                      placeholder='none'
                      alt={props.floatingFirst.alt}
                      image={getImage(props.floatingFirst.gatsbyImageData)}
                      className={[styles.floatingFirstImage]}
                    />
                  )}
                  {props.floatingSecond && (
                    <Base
                      as={GatsbyImage}
                      placeholder='none'
                      alt={props.floatingSecond.alt}
                      image={getImage(props.floatingSecond.gatsbyImageData)}
                      className={[styles.floatingSecondImage]}
                    />
                  )}
                  {props.floatingThird && (
                    <Base
                      as={GatsbyImage}
                      placeholder='none'
                      alt={props.floatingThird.alt}
                      image={getImage(props.floatingThird.gatsbyImageData)}
                      className={[styles.floatingThirdImage]}
                    />
                  )}
                  {props.image && (
                    <Base
                      as={GatsbyImage}
                      placeholder='none'
                      alt={props.image.alt}
                      image={getImage(props.image.gatsbyImageData)}
                      className={[styles.heroImage]}
                    />
                  )}
                </Base>
              </Base>
            </Base>
          </Box>
        </Flex>
      </Container>
    </BackgroundSection>
  )
}

export const query = graphql`
  fragment HomepageHeroContent on HomepageHero {
    id
    kicker
    h1: heading
    subhead
    text
    links {
      id
      href
      text
    }
    image {
      id
      gatsbyImageData
      alt
    }
    floatingFirst {
      id
      gatsbyImageData
      alt
    }
    floatingSecond {
      id
      gatsbyImageData
      alt
    }
    floatingThird {
      id
      gatsbyImageData
      alt
    }
    background {
      id
      gatsbyImageData
      alt
    }
  }
`
